module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "700px",
      "persistent": ""
    },
    on: {
      "update:returnValue": _vm.setEditItemIdZero
    },
    model: {
      value: (_vm.dialogResult),
      callback: function($$v) {
        _vm.dialogResult = $$v
      },
      expression: "dialogResult"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Login"
    },
    model: {
      value: (_vm.itemData.username),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "username", $$v)
      },
      expression: "itemData.username"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.itemData.name),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "name", $$v)
      },
      expression: "itemData.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Phone"
    },
    model: {
      value: (_vm.itemData.phone),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "phone", $$v)
      },
      expression: "itemData.phone"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Age",
      "type": "number"
    },
    model: {
      value: (_vm.itemData.age),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "age", $$v)
      },
      expression: "itemData.age"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.sex,
      "label": "Sex"
    },
    model: {
      value: (_vm.itemData.sex),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "sex", $$v)
      },
      expression: "itemData.sex"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "outline": "",
      "label": "Description"
    },
    model: {
      value: (_vm.itemData.description),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "description", $$v)
      },
      expression: "itemData.description"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Email"
    },
    model: {
      value: (_vm.itemData.email),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "email", $$v)
      },
      expression: "itemData.email"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.rolesList,
      "multiple": "",
      "label": "Roles"
    },
    model: {
      value: (_vm.selectedRoles),
      callback: function($$v) {
        _vm.selectedRoles = $$v
      },
      expression: "selectedRoles"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "password",
      "type": "password"
    },
    model: {
      value: (_vm.itemData.password),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "password", $$v)
      },
      expression: "itemData.password"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Is bookable"
    },
    model: {
      value: (_vm.itemData.is_vendor),
      callback: function($$v) {
        _vm.$set(_vm.itemData, "is_vendor", $$v)
      },
      expression: "itemData.is_vendor"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": ""
    }
  }, [(_vm.avatar) ? _c('v-img', {
    attrs: {
      "size": "50",
      "aspect-ratio": "1",
      "src": _vm.avatar
    }
  }) : _vm._e(), _vm._v(" "), (_vm.uploadPercentage !== 0 && _vm.uploadPercentage !== 100) ? _c('v-progress-linear', {
    attrs: {
      "value": _vm.uploadPercentage,
      "color": "light-blue"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mt-3 ml-0",
    attrs: {
      "color": "primary",
      "disabled": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "loading": _vm.disabled.uploadPhotoForEmbalmersBtn,
      "prepend-icon": _vm.uploadStatus,
      "type": "file"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.inputUpload.click()
      }
    }
  }, [_vm._v("Upload Optional Photo\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    ref: "inputUpload",
    attrs: {
      "accept": ".jpg,.png",
      "type": "file"
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }), _vm._v(" "), (_vm.courses.length > 0) ? _c('v-flex', {
    staticClass: "text-md-left",
    attrs: {
      "xs12": "",
      "sm6": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.courses,
      "headers": _vm.coursesTableHeaders,
      "hide-actions": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.item.course_id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.course_completion_percent))])]
      }
    }], null, false, 3030427828)
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.editItemDataDecorator.apply(null, arguments)
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.dialogClose.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e9498be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/AppEditUsersDialog.vue
// module id = 972
// module chunks = 1